import { useEffect, useState } from 'react';
//import dayjs from 'dayjs';

import {
  ClientResponse,
  EmployeeResponse,
  MatchCandidateResponse
} from 'generated/index';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Event } from 'components/roster-portal/activity-planning/types';

import {
  getClientInitials,
  getClientName,
  getEmployeeInitials
} from 'components/roster-portal/activity-planning/utils';

import { queries } from 'RestAPIs/rapini';

import { Box, Chip } from '@mui/material';

import {
  ControlledAutoComplete,
  ControlledSearch
} from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import ClientAvatar from '../../ClientAvatar/ClientAvatar';
import { FieldKey } from '../input-field-grants';
import { OrganizationalUnit } from 'components/types';

type Props = {
  enable?: boolean;
  candidateEmployment?: MatchCandidateResponse | null;
  control: Control<any>;
  event?: Event;
  client?: ClientResponse | null;
  clients?: ClientResponse[];
  employee?: EmployeeResponse | null;
  organizationalUnit?: OrganizationalUnit;
  hasFieldGrant: (key: FieldKey) => boolean;
  handleEmployeeSelect: (employee: EmployeeResponse | undefined | null) => void;
  handleCandidateEmploymentSelect?: (
    candidate: MatchCandidateResponse | undefined | null
  ) => void;
};

const WhoSection = ({
  enable,
  //candidateEmployment,
  control,
  client,
  clients,
  employee,
  event,
  //organizationalUnit,
  hasFieldGrant,
  handleEmployeeSelect //handleCandidateEmploymentSelect
}: Props) => {
  const { t } = useTranslation();

  if (!enable) return null;

  const clientPreview = (
    <Box display="flex" width="100%" alignItems="start">
      <Chip
        size="small"
        avatar={
          <ClientAvatar
            sx={{
              width: 24,
              height: 24,
              bgcolor: 'dark.main',
              fontSize: '14px'
            }}
            // TODO: employee lacks base64image
            base64Image={
              hasFieldGrant('CLIENT_AVATAR')
                ? event?.clients[0]?.base64Image
                : hasFieldGrant('EMPLOYEE_AVATAR')
                ? ''
                : ''
            }
            alt={
              hasFieldGrant('CLIENT_AVATAR')
                ? getClientInitials(client)
                : hasFieldGrant('EMPLOYEE_AVATAR')
                ? getEmployeeInitials(event?.employees?.[0])
                : ''
            }
          />
        }
        label={
          hasFieldGrant('CLIENT_AVATAR')
            ? getClientName(client)
            : hasFieldGrant('EMPLOYEE_AVATAR')
            ? employee?.nameInformal
            : ''
        }
      />
    </Box>
  );

  return (
    <MultiStepForm.Section
      title="Wie"
      isEditable={hasFieldGrant('WHO_IS_EDITABLE')}
      isPreview={hasFieldGrant('WHO_IS_PREVIEW')}
      validateFields={['employee']}
      preview={clientPreview}
    >
      {/* {hasFieldGrant('CLIENT') &&
        hasFieldGrant('WHO_IS_PREVIEW') &&
        clientPreview} */}

      {/* {hasFieldGrant('CLIENT') && !hasFieldGrant('WHO_IS_PREVIEW') && (
        <ControlledAutoComplete
          name="client"
          control={control}
          label={t('client')}
          variant="outlined"
          options={
            clients?.map((client) => ({
              ...client,
              name: `${client.number} - ${getClientName(client)}`,
              sortName: client.lastName + ' ' + client.firstName
            })) ?? []
          }
          sortByProp={'sortName'}
          fullWidth
        />
      )} */}

      {hasFieldGrant('CLIENT') && (
        <ControlledAutoComplete
          name="client"
          control={control}
          label={t('client')}
          variant="outlined"
          options={
            clients?.map((client) => ({
              ...client,
              name: `${client.number} - ${getClientName(client)}`,
              sortName: client.lastName + ' ' + client.firstName
            })) ?? []
          }
          sortByProp={'sortName'}
          fullWidth
        />
      )}

      {hasFieldGrant('EMPLOYEE') && (
        <EmployeeSelect
          control={control}
          employee={employee}
          handleSelect={handleEmployeeSelect}
        />
      )}

      {/* {hasFieldGrant('CANDIDATE_EMPLOYMENT') && (
        <CandidateEmploymentSelect
          control={control}
          candidate={candidateEmployment}
          event={event}
          handleSelect={handleCandidateEmploymentSelect}
          organizationalUnit={organizationalUnit}
        />
      )} */}
    </MultiStepForm.Section>
  );
};

const EmployeeSelect = ({
  control,
  employee,
  handleSelect
}: {
  control: Control<any>;
  employee?: EmployeeResponse | null;
  handleSelect?: (employee: EmployeeResponse | null) => void;
}) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState<string>('');

  const {
    data: employees,
    isLoading,
    refetch
  } = queries.useGetEmployees(undefined, undefined, query, {
    enabled: false
  });

  useEffect(() => {
    if (query?.length > 0) {
      refetch();
    }
  }, [query]);

  return (
    <ControlledSearch
      name="employee"
      control={control}
      idProperty="entityId"
      label={t('employee')}
      labelProperty="label"
      noOptionsText={t('searchEmployee')}
      loading={isLoading}
      fullWidth
      debounceInMS={500}
      options={(employees || []).map((employee: EmployeeResponse) => ({
        label: employee?.nameInformal || '',
        ...employee
      }))}
      value={
        employee && {
          label: employee?.nameInformal || '',
          ...employee
        }
      }
      onQueryChange={setQuery}
      onChange={handleSelect}
    />
  );
};

// const CandidateEmploymentSelect = ({
//   control,
//   candidate,
//   event,
//   handleSelect,
//   organizationalUnit
// }: {
//   control: Control<any>;
//   candidate?: MatchCandidateResponse | null;
//   event?: Event;
//   handleSelect?: (candidate: MatchCandidateResponse | undefined | null) => void;
//   organizationalUnit?: OrganizationalUnit;
// }) => {
//   const { t } = useTranslation();
//   const [query, setQuery] = useState<string>('');

//   const {
//     data: candidates,
//     isFetching: isFetchingCandidates,
//     refetch
//   } = queries.useFindMatchCandidatesForAppointments(
//     event?.id || '',
//     dayjs(event?.start)
//       .startOf('day')
//       .format('YYYY-MM-DD'),
//     //@ts-expect-error TODO: BE should accept array of ids
//     query.length > 0 ? undefined : organizationalUnit?.id,
//     query.length > 0 ? query : undefined,
//     {
//       enabled: false
//     }
//   );

//   useEffect(() => {
//     refetch();
//   }, [query]);

//   const getLabel = (candidate: MatchCandidateResponse) => {
//     if (!candidate) return '';

//     const name = candidate?.employeeName;
//     const id = candidate?.employeeNumber;
//     const contractNumber = candidate?.employmentNumber;
//     return `${name} (${id}) - #${contractNumber}`;
//   };

//   return (
//     <ControlledSearch
//       name="candidateEmployment"
//       control={control}
//       idProperty="employmentEntityId"
//       label={t('employee')}
//       labelProperty="label"
//       noOptionsText={t('searchEmployee')}
//       loading={isFetchingCandidates}
//       showOptionsOnFocus
//       fullWidth
//       debounceInMS={500}
//       options={(candidates || []).map((candidate: MatchCandidateResponse) => ({
//         label: getLabel(candidate),
//         ...candidate
//       }))}
//       value={
//         candidate && {
//           label: getLabel(candidate),
//           ...candidate
//         }
//       }
//       onQueryChange={setQuery}
//       onChange={handleSelect}
//     />
//   );
// };

export default WhoSection;
